
import { Component, Vue, Model } from "vue-property-decorator";
import { IdentityProvidersModel, ProviderType } from "@flosum-auth/contracts";
import AppCard from "@/modules/shared/components/AppCard.vue";
import AppInput from "@/modules/shared/components/AppInput.vue";
import AppSelect from "@/modules/shared/components/AppSelect.vue";
import { IdentityProvidersValidators } from "@/modules/identity-providers/identity-providers.validators";

export type IdentityProvidersBasicInformationData = Pick<IdentityProvidersModel, "name" | "type">;

@Component({
  components: {
    AppCard,
    AppInput,
    AppSelect,
  },
})
export default class IdentityProvidersBasicInformation extends Vue {
  @Model("changed")
  public readonly model!: IdentityProvidersBasicInformationData | null;

  public readonly validators = {
    name: [IdentityProvidersValidators.isName],
    connectionMethod: [IdentityProvidersValidators.isConnectionMethod],
  };

  public get typeItems(): string[] {
    return Object.values(ProviderType);
  }

  public getValue<K extends keyof IdentityProvidersBasicInformationData>(
    key: K,
    defaultValue: IdentityProvidersBasicInformationData[K]
  ): IdentityProvidersBasicInformationData[K] {
    return (this.model && this.model[key]) || defaultValue;
  }

  public update<K extends keyof IdentityProvidersBasicInformationData>(
    key: K,
    value: IdentityProvidersBasicInformationData[K]
  ): void {
    this.$emit("changed", {
      ...this.model,
      [key]: value,
    });
  }
}
